import { render, staticRenderFns } from "./PatentAnnuityList.vue?vue&type=template&id=8fa595b2&"
import script from "./PatentAnnuityList.vue?vue&type=script&lang=js&"
export * from "./PatentAnnuityList.vue?vue&type=script&lang=js&"
import style0 from "./PatentAnnuityList.vue?vue&type=style&index=0&id=8fa595b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports